<ng-container *ngIf="user && week?.days?.length">
  <h4 class="availability-week-item__title">
    {{ ("calendarWeek" | i18n) || "CW" }} {{ weekNumber }} /
    {{ week?.weekStartDate | date }} - {{ week?.weekEndDate | date }}
  </h4>

  <div class="availability-week-item__days-wrapper">
    <app-availability-day-item
      *ngFor="let day of week?.days; trackBy: trackByDay"
      [date]="day.utcDate"
      [user]="user">
    </app-availability-day-item>
  </div>
</ng-container>
